/* eslint-disable react/destructuring-assignment */
import React, { useCallback } from 'react';

import { Box, makeStyles } from '@material-ui/core';
import moment from 'moment';
import Ship from '../../../common/data-types/ship-data';
import { LEGEND_ITEMS } from '../../../common/constants/legend-items';
import LegendItem from '../../../common/data-types/legend-item-data';

const useStyles = makeStyles({
  cell: {
    '&:first-child': {
      minWidth: '200px',
      maxWidth: '200px',
      position: 'sticky',
      left: '0px',
      zIndex: '1',
    },
    borderBottom: '1px solid rgb(236, 236, 236)',
    borderRight: '1px solid rgb(236, 236, 236)',
    fontSize: '12px',
    minWidth: '100px',
    padding: '1rem 1rem',
    textAlign: 'center',
  },
  statusColor: {
    height: '20px',
    width: '20px',
  },
});

interface ListItem {
  data: Ship;
}

const ListItem = ({ data }: ListItem) => {
  const classes = useStyles();

  const getStatus = (status: Ship['status']) => {
    return LEGEND_ITEMS.find((item: LegendItem) => item.description === status)
      ?.color;
  };

  return (
    <Box display="flex" style={{ backgroundColor: getStatus(data?.status) }}>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {data?.ship}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {data?.trip}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {Boolean(data?.forecastArrival) &&
          moment
            .utc(data?.forecastArrival)
            .format('DD/MM/YYYY HH:mm')
            .toString()}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {Boolean(data?.arrival) &&
          moment.utc(data?.arrival).format('DD/MM/YYYY HH:mm').toString()}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {Boolean(data?.forecastMooring) &&
          moment
            .utc(data?.forecastMooring)
            .format('DD/MM/YYYY HH:mm')
            .toString()}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {Boolean(data?.mooring) &&
          moment.utc(data?.mooring).format('DD/MM/YYYY HH:mm').toString()}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {Boolean(data?.operationStart) &&
          moment
            .utc(data?.operationStart)
            .format('DD/MM/YYYY HH:mm')
            .toString()}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {Boolean(data?.forecastDeparture) &&
          moment
            .utc(data?.forecastDeparture)
            .format('DD/MM/YYYY HH:mm')
            .toString()}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {Boolean(data?.finish) &&
          moment.utc(data?.finish).format('DD/MM/YYYY HH:mm').toString()}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {Boolean(data?.departure) &&
          moment.utc(data?.departure).format('DD/MM/YYYY HH:mm').toString()}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {Boolean(data?.gateOpening) &&
          moment.utc(data?.gateOpening).format('DD/MM/YYYY HH:mm').toString()}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {Boolean(data?.deadline) &&
          moment.utc(data?.deadline).format('DD/MM/YYYY HH:mm').toString()}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {data?.joint}
      </Box>
      <Box
        className={classes.cell}
        style={{ backgroundColor: getStatus(data?.status) }}
      >
        {data?.cradle}
      </Box>
    </Box>
  );
};

export default ListItem;
